import type { ComponentPropsWithoutRef } from "react";

import { cn } from "../../lib/cn";

export type SkeletonProps = ComponentPropsWithoutRef<"div">;

export function Skeleton({ className, ...rest }: SkeletonProps) {
  return (
    <div
      aria-hidden="true"
      className={cn("bg-fill motion-safe:animate-pulse rounded-md", className)}
      {...rest}
    />
  );
}
